import { faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ENDPOINT_COMPONENT, ENDPOINT_MESSAGE } from '../Config';
import useProps from '../hooks/useProps';
import { useParams } from 'react-router-dom';
import useEventCtx from '../hooks/useEventCtx';

const URL_REGEX = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;

const MessageConfiguration = ({ onReady }) => {
    const { groupId } = useParams();
    const { props } = useProps();
    const { event, setEvent } = useEventCtx();
    const [emailMessage, setEmailMessage] = useState();
    const [smsMessage, setSmsMessage] = useState();
    const [socialMessage, setSocialMessage] = useState();
    const [ctaText, setCtaText] = useState();
    const [ctaLink, setCtaLink] = useState();
    const [validCta, setValidCta] = useState(false);
    const [messageSaving, setMessageSaving] = useState(false);
    const [messageLoaded, setMessageLoaded] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState(false);
    const messageRef = useRef();
    const smsRef = useRef();
    const socialMessageRef = useRef();
    const ctaTextRef = useRef();
    const ctaLinkRef = useRef();
    const axiosPrivate = useAxiosPrivate();

    const handleMessage = async () => {
        setMessageSaving(true);
        try {
            const response = await axiosPrivate.put(ENDPOINT_MESSAGE.replace('{groupId}', groupId), {
                "invitationEmailMessage": emailMessage,
                "invitationSmsMessage": smsMessage,
                "socialMediaMessage": socialMessage,
                "ctaText": ctaText,
                "ctaLink": ctaLink
            });
            if (response.status == 200) {
                setEvent((prev) => ({
                    ...prev,
                    invitationEmailMessage: emailMessage,
                    invitationSmsMessage: smsMessage
                }));
                setMessageSuccess(true);
                setTimeout(() => setMessageSuccess(false), 5000);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setMessageSaving(false);
        }
    };
    useEffect(() => {
        setValidCta(!ctaLink || ctaLink === '' || URL_REGEX.test(ctaLink));
    }, [ctaLink])

    useEffect(() => {
        const loadMessage = async () => {
            const response = await axiosPrivate.get(ENDPOINT_COMPONENT.replace('{groupId}', groupId));
            setMessageLoaded(true);
            const eventName = response?.data?.eventName ? response.data.eventName : "[Event name]";
            if (response?.data?.invitationEmailMessage) {
                setEmailMessage(response.data.invitationEmailMessage);
            } else {
                setEmailMessage(props.invitationEmail.replace('{eventName}', eventName));
            }
            if (response?.data?.invitationSmsMessage) {
                setSmsMessage(response.data.invitationSmsMessage);
            } else {
                setSmsMessage(props.invitationSms.replace('{eventName}', eventName));
            }
            if (response?.data?.socialMediaMessage) {
                setSocialMessage(response.data.socialMediaMessage);
            } else {
                setSocialMessage(props.socialMessage.replace('{eventName}', eventName));
            }
            if (response?.data?.ctaText) {
                setCtaText(response.data.ctaText);
            }
            if (response?.data?.ctaLink) {
                setCtaLink(response.data.ctaLink);
            }
            if (typeof onReady === 'function') {
                onReady(response?.data);
            }
        }
        loadMessage();
    }, [])

    return (
        <>
            {messageLoaded ?
                <div>
                    <div className='mb-3'>
                        <label htmlFor="email_message" className="form-label">Email Message to Your {props.speaker}s</label>
                        <textarea id='email_message' className='form-control' rows={8}
                            onChange={e => setEmailMessage(e.target.value)}
                            ref={messageRef}
                            value={emailMessage}></textarea>
                        <div className="form-text">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon> You can use those placeholders: <br /><kbd>{'{participant_first_name}'}</kbd> <kbd>{'{participant_last_name}'}</kbd> <kbd>{'{participant_full_name}'}</kbd>
                        </div>
                    </div>
                    <div className='mb-3 d-none'>
                        <label htmlFor="sms_message" className="form-label">SMS Message to Your {props.speaker}s</label>
                        <span className="float-end text-muted small mt-1"><small>Max (130 chars)</small></span>
                        <input type='text' id='sms_message' className='form-control' maxLength='130'
                            onChange={e => setSmsMessage(e.target.value)}
                            ref={smsRef}
                            value={smsMessage} />
                    </div>
                    <div className="form-text">
                        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon> Record link will be automatically added to your messages.
                    </div>
                    <hr />
                    <div className='mb-3'>
                        <label htmlFor="social_message" className="form-label">Suggested Social Media Message</label>
                        <textarea id='social_message' className='form-control' rows={2}
                            onChange={e => setSocialMessage(e.target.value)}
                            ref={socialMessageRef}
                            value={socialMessage}></textarea>
                    </div>
                    <div className='mb-3'>
                        <label htmlFor="cta_text" className="form-label">
                            {props.eventRegistrationText}
                        </label>
                        <span className="float-end text-muted small mt-1"><small>Default: "Learn More"</small></span>
                        <input type="text" id="cta_text"
                            className="form-control"
                            onChange={e => setCtaText(e.target.value)}
                            ref={ctaTextRef}
                            value={ctaText}
                            maxLength="45"
                        />
                    </div>
                    <div className='mb-3'>
                        <label htmlFor="cta_link" className="form-label">
                            {props.eventRegistrationLink}
                        </label>
                        <span className="float-end text-muted small mt-1"><small>Example: https://domain.com/page</small></span>
                        <input type='text' id='cta_link'
                            className={`form-control ${!validCta ? "is-invalid" : ""}`}
                            onChange={e => setCtaLink(e.target.value)}
                            ref={ctaLinkRef}
                            value={ctaLink}
                            aria-invalid={validCta ? "false" : "true"}
                        />
                    </div>
                    <button type="button" className="btn btn-primary" onClick={handleMessage} disabled={messageSaving || !validCta}>
                        {messageSaving ?
                            <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving message</>
                            : event?.invitationEmailMessage ? "Save message" : "Next"
                        }
                    </button>
                    <span className='ms-3'>
                        {messageSuccess &&
                            <span className="text-success">
                                <FontAwesomeIcon icon={faCheck} /> saved
                            </span>
                        }
                    </span>
                </div>
                :
                <div className="spinner-grow">
                    <span className="visually-hidden">Loading...</span>
                </div>
            }
        </>
    )
}

export default MessageConfiguration;
